import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders children directly into document.body, bypassing any ancestor
 * that might constrain position:fixed descendants (transforms, flex stacking
 * contexts, etc). Use for overlays/modals that must always cover the full
 * viewport regardless of where they're mounted in the component tree.
 */
export function Portal({ children }: { children: ReactNode }) {
  return createPortal(children, document.body);
}
